export default __webpack_public_path__ + "static/media/programmes-icon.54426284.svg";